// extracted by mini-css-extract-plugin
module.exports = {"hover":"bottom-link_hover__bC2DD","bottomCtaIcon":"bottom-link_bottomCtaIcon__4do81"};